import React, { useEffect, useState } from "react";
import "./ThankyouPage.scss";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BOOKING_ID } from "../../../constants";
import { isAutoServicesTenant } from "../../../utils/tenantBranding";

interface IPROPS {
  setIsCartOpen: any;
}

const ThankyouPage: React.FC<IPROPS> = ({ setIsCartOpen }) => {
  const [thanyouData, setThankyouData] = useState<any>({});
  const navigate = useNavigate();

  const request_id = localStorage.getItem(BOOKING_ID);
  const token = localStorage.getItem("customer-token");
  const fetchingTenant = window.location.hostname.split(".")[0];
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);
  const apiPort = process.env.REACT_APP_API_PROTOCOL;

  console.log(request_id, "request_id");

  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/${request_id}/thank-you/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response, "scscdsdcsdcs");
      setThankyouData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  console.log(thanyouData, "thanyouData");

  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        {/* Header with Logo */}
        <div className="thankyou-logo-row">

        {autoServicesBranding ? (
          <img src="https://botgobucket.s3.ap-south-1.amazonaws.com/AutoServices/Logo+1.svg" alt="Auto Services logo" style={{ width: "300px" ,height:"100px"}} />
        ) : (
          <img
            src="https://botgobucket.s3.ap-south-1.amazonaws.com/ercs+images/europearlogo.png"
            alt="Brand logo"
            className="thankyou-logo"
          />
        )}
        </div>

        {/* Success Icon and Message */}
        <div className="thankyou-success-block">
          <div className="thankyou-success-icon">
            <img
              src="https://img.icons8.com/ios-filled/100/26e07f/ok.png"
              alt="success"
            />
          </div>
          <div className="thankyou-success-text">
            <h2>Thank You for Choosing {autoServicesBranding ? "Auto Services!" : "EUROREPAR!"}</h2>
            <p>
              We’ve received your booking request, you’ll receive confirmation
              soon.
            </p>
          </div>
        </div>

        {/* Info Sections */}
        <div className="thankyou-sections cards-grid">
          {/* Appointment Details */}
          <div className="info-card">
            <div className="info-header">
              <i
                className="bi bi-calendar info-header-icon"
                aria-hidden="true"
              ></i>
              <span style={{ fontFamily: "Karbon-medium" }}>
                Appointment Details
              </span>
            </div>
            <div className="info-table">
              <div className="info-row">
                <div
                  className="info-label"
                  style={{ fontFamily: "Karbon-semi" }}
                >
                  Booking ID
                </div>
                <div
                  className="info-value"
                  style={{ fontFamily: "Karbon-medium" }}
                >
                  {thanyouData?.booking_id}
                </div>
              </div>
              <div className="info-row">
                <div
                  className="info-label"
                  style={{ fontFamily: "Karbon-semi" }}
                >
                  Date
                </div>
                <div
                  className="info-value"
                  style={{ fontFamily: "Karbon-medium" }}
                >
                  {thanyouData?.appointment_details?.date}
                </div>
              </div>
              <div className="info-row">
                <div
                  className="info-label"
                  style={{ fontFamily: "Karbon-semi" }}
                >
                  Time
                </div>
                <div
                  className="info-value"
                  style={{ fontFamily: "Karbon-medium" }}
                >
                  {thanyouData?.appointment_details?.time}
                </div>
              </div>
              {/* <div className="info-row">
                <div className="info-label">Duration</div>
                <div className="info-value">2-3 hours</div>
              </div> */}
            </div>
          </div>

          {/* Service Center Information */}
          <div className="info-card">
            <div className="info-header">
              <i
                className="bi bi-geo-alt info-header-icon"
                aria-hidden="true"
              ></i>
              <span>Service Center Information</span>
            </div>
            <div className="info-card-content">
              <div className="info-card-left">
                <div className="center-name info-bold">
                  {autoServicesBranding ? "Auto Services Center" : "ERCS Service Center"}
                </div>
                <div
                  className="center-address"
                  style={{ fontFamily: "Karbon-medium" }}
                >
                  {thanyouData?.service_center_information?.address}
                </div>
              </div>
              <div className="info-card-right">
                <div className="info-row">
                  <div className="info-label">Service Manager</div>
                  <div
                    className="info-value info-bold"
                    style={{ fontFamily: "Karbon-medium" }}
                  >
                    {thanyouData?.service_center_information?.service_manager}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">Phone Number</div>
                  <div
                    className="info-value info-bold"
                    style={{ fontFamily: "Karbon-medium" }}
                  >
                    {thanyouData?.service_center_information?.phone_number}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Services Booked */}
          <div className="info-card">
            <div className="info-header">
              <i
                className="bi bi-wrench info-header-icon"
                aria-hidden="true"
              ></i>
              <span>Services Booked</span>
            </div>
            <ul className="services-list">
              {thanyouData?.services_booked?.map((el: any, index: any) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Karbon-regular",
                    gap: "5px",
                  }}
                >
                  <span>{index + 1}.</span>

                  <li style={{ marginBottom: "0" }}>{el}</li>
                </div>
              ))}
              {/* <li>
                <i className="bi bi-exclamation-circle service-icon" aria-hidden="true"></i>
                Brakes
              </li>
              <li>
                <i className="bi bi-circle service-icon" aria-hidden="true"></i>
                Tyres
              </li>
              <li>
                <i className="bi bi-snow service-icon" aria-hidden="true"></i>
                AC Repairing
              </li> */}
            </ul>
          </div>

          {/* Vehicle Information */}
          <div className="info-card vehicle-info-card">
            <div className="info-header">
              <i
                className="bi bi-car-front info-header-icon"
                aria-hidden="true"
              ></i>
              <span>Vehicle Information</span>
            </div>
            <div className="vehicle-info-table">
              <div className="vehicle-info-row">
                <div className="vehicle-info-label">Make/ Model</div>
                <div className="vehicle-info-label"></div>
                <div className="vehicle-info-value"></div>
                <div className="vehicle-info-value">
                  {`${thanyouData?.vehicle_information?.brand || ""} / ${
                    thanyouData?.vehicle_information?.model || ""
                  }`}
                </div>{" "}
              </div>
              <div className="vehicle-info-row">
                <div className="vehicle-info-label">Year</div>
                <div className="vehicle-info-value">
                  {thanyouData?.vehicle_information?.year}
                </div>
                <div className="vehicle-info-label">License Plate</div>
                <div className="vehicle-info-value">
                  {thanyouData?.vehicle_information?.license_plate}
                </div>
              </div>
              {/* <div className="vehicle-info-row">
    <div className="vehicle-info-label">Color</div>
    <div className="vehicle-info-value">Silver</div>
    <div className="vehicle-info-label">Current Mileage</div>
    <div className="vehicle-info-value">45,230 miles</div>
  </div> */}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div
          className="thankyou-actions"
          style={{ display: "flex", justifyContent: "center", gap: "20px" }}
        >
          <button
            className="thankyou-action-btn support"
            onClick={() => navigate("/home")}
          >
            <img
              src="https://img.icons8.com/ios-filled/20/ffb980/circled-left-2.png"
              alt="Back to Home"
            />
            Home
          </button>

          <button
            className="thankyou-action-btn book"
            onClick={() => {
              setIsCartOpen(false); // close cart if it was open
              navigate("/vehicle/select"); // navigate to vehicle selection
            }}
          >
            Book Another Service
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankyouPage;
